module.exports = __webpack_public_path__ + "img/bg-hero-icons.59f82096.svg";